import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import logoWh from "/src/images/icons/logo_white.png"

const staticPages = [
  {
    type: 1,
    name: "ホーム",
    slug: "",
  },
  {
    type: 2,
    name: "SUNWAYについて",
    slug: "about",
  },
  {
    type: 3,
    name: "お任せいただける理由",
    slug: "service",
  },
  {
    type: 4,
    name: "製造可能な製品",
    slug: "https://www.sunway.co.jp/product",
  },
  {
    type: 5,
    name: "制作事例",
    slug: "https://www.sunway.co.jp/case",
  },
  {
    type: 6,
    name: "ご依頼から制作までの流れ",
    slug: "flow",
  },
  {
    type: 7,
    name: "よくある質問",
    slug: "faq",
  },
  {
    type: 8,
    name: "記事",
    slug: "articles",
  },
  {
    type: 9,
    name: "お問い合わせ",
    slug: "contact",
  },
]
const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata
const footer = json.footer
const pageConstruct = json.pageConstruct
let pageConstructAddition = staticPages

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header>
      <Link to="/" className={style.logo}>
        {/* <img src={logoUri} alt={siteMetaData.title}/> */}
        <img src={logoWh} alt={siteMetaData.title} />
      </Link>
      <nav className={style.nav}>
        <ul className={style.nav_list}>
          {pageConstructAddition.map((props, index) => {
            if (props.type === 8) {
              return (
                <li className={style.nav_item} key={index}>
                  <Link to={`/${props.slug}/p/1`}>
                    {props.name}
                  </Link>
                </li>
              )
            }
            if (props.type == 4 || props.type == 5) {
              return (
                <li className={style.nav_item} key={index}>
                  <Link to={`${props.slug}`} target="_blank">{props.name}</Link>
                </li>
              )
            }
            if (props.type === 9) {
              return (
                <div className={`${style.nav_item} ${style.contact}`}>
                  <Link to={`/${props.slug}`}>{props.name}</Link>
                </div>
              )
            }
            return (
              <li className={style.nav_item} key={index}>
                <Link to={`/${props.slug}`}>{props.name}</Link>
              </li>
            )
          })}
        </ul>
      </nav>
      <button
        className={style.menu}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          <StaticImage
            src="../../images/icons/menu-open.svg"
            placeholder="none"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            alt="開く"
          />
        ) : null}
      </button>
      {isOpen ? (
        <div className={style.sp_menu}>
          <button
            className={style.close_btn}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <StaticImage
              src="../../images/icons/menu-close.svg"
              placeholder="none"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              alt="閉じる"
            />
          </button>
          <nav className={style.sp_nav}>
            <ul className={style.sp_nav_list}>
              {pageConstructAddition.map((props, index) => {
                if (props.type === 4) {
                  return (
                    <li className={style.sp_nav_item} key={index}>
                      <Link to={`/${props.slug}/p/1`}>
                        {props.slug.toUpperCase()}
                      </Link>
                    </li>
                  )
                }
                if (props.type !== 1 && props.type !== 5) {
                  return (
                    <li className={style.sp_nav_item} key={index}>
                      <Link to={`/${props.slug}`}>
                        {props.slug.toUpperCase()}
                      </Link>
                    </li>
                  )
                }
                return null
              })}
            </ul>
            <div className={style.sns_link}>
              {footer.facebookUrl && (
                <Link to={footer.facebookUrl}>
                  <StaticImage
                    src="../../images/icons/sns-facebook-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="facebook"
                  />
                </Link>
              )}
              {footer.instagramUrl && (
                <Link to={footer.instagramUrl}>
                  <StaticImage
                    src="../../images/icons/sns-instagram-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="instagram"
                  />
                </Link>
              )}
              {footer.lineUrl && (
                <Link to={footer.lineUrl}>
                  <StaticImage
                    src="../../images/icons/sns-line-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="line"
                  />
                </Link>
              )}
              {footer.xUrl && (
                <Link to={footer.xUrl}>
                  <StaticImage
                    src="../../images/icons/sns-x-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="x"
                  />
                </Link>
              )}
              {footer.blogUrl && (
                <Link to={footer.blogUrl}>
                  <StaticImage
                    src="../../images/icons/sns-blog-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="blog"
                  />
                </Link>
              )}
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Component
